module.exports = __webpack_public_path__ + "static/media/mainimg-02.c0527d1f.png";